import React from 'react';

const ModalConsent = ({
                          onClose,
                          consentToDiscloseData,
                          setConsentToDiscloseData,
                          handleConsentSubmit
                      }) => {

    return (
        <div className="modal fade" id="consentModal" tabIndex="-1" aria-labelledby="consentModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="consentModalLabel">Consentimento para Divulgação de Dados</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={() =>onClose()}></button>
                    </div>
                    <div className="modal-body">
                        <p>Para continuar com o processo de solicitação, você precisa consentir com a divulgação dos seus dados.</p>
                        <p>Por favor, leia o <a href="/consent-form" target="_blank">Termo de Consentimento</a> e marque a caixa abaixo se estiver de acordo.</p>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={consentToDiscloseData}
                                onChange={() => setConsentToDiscloseData(!consentToDiscloseData)}
                            />
                            <label className="form-check-label">
                                Eu li e concordo com o <a href="/consent-form" target="_blank">Termo de Consentimento</a>.
                            </label>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"  onClick={() =>onClose()}>Cancelar</button>
                        <button type="button" className="btn btn-primary"  onClick={() =>handleConsentSubmit()}>
                            Consentir
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalConsent;
